import { UseUserCalendarReturnDataItem } from 'modules/calendar/hooks/useUserCalendar';
import React, { useMemo } from 'react';
import { ActionOption, ActionPopover } from 'components/ActionPopover';
import { UserCalendarStatus } from 'generated-graphql/types';
import { Box } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import { Delete } from '@mui/icons-material';

export const UserCalendarActions = ({
  userCalendar,
  onRemove,
  onResendInvite
}: {
  userCalendar: UseUserCalendarReturnDataItem;
  onRemove: () => void;
  onResendInvite: () => void;
}) => {
  const rowActionsOptions = useMemo<ActionOption[]>(() => {
    const options: ActionOption[] = [];

    if (userCalendar.status === UserCalendarStatus.Invited) {
      options.push({
        label: 'Resend invite',
        onClick: onResendInvite,
        icon: <SendIcon />
      });
    }

    options.push({
      label: 'Delete',
      onClick: onRemove,
      icon: <Delete />,
      itemColor: 'error.main'
    });

    return options;
  }, [userCalendar, onRemove, onResendInvite]);

  return (
    <Box sx={{ display: 'flex' }}>
      {rowActionsOptions.length > 0 && (
        <ActionPopover
          id={userCalendar.id}
          options={rowActionsOptions}
          iconSx={{ color: 'primary.main' }}
        />
      )}
    </Box>
  );
};
